import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import RichText from 'app/components/RichText';

const styles = theme => ({
  textField: {
    marginTop: theme.spacing.unit * 2,
  },
  submitButton: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    width: '90px',
  },
  popupContentContainer: {
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit * 3,
  },
  link: {
    color: theme.palette.primary.main,
  },
  root: {
    alignItems: 'start',
  },
  label: {
    fontWeight: 'bold',
    lineHeight: '1.2',
    alignSelf: 'center',
  }
});

class On9PopupView extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.popupContentContainer}>
        <RichText content={"<p>This Operation Manual is confidential and proprietary, intended exclusively for authorized activities related to ARIA operations. By accessing this manual, you agree to the following conditions:</p>"} />
        <RichText content={"<ol><li>You shall not use this manual for any purpose other than authorized ARIA operations.</li><li>You shall not share, distribute, or disclose its contents to any third party without prior written consent.</li><li>You shall not publish, post, or make this manual available on any website, social media, or other public platform.</li></ol>"} />
        <RichText content={"<p>Unauthorized use or distribution of this manual may result in legal action. For questions regarding permitted uses, please contact ARIA administration.</p>"} />
        <ul><li><Typography>
          <a className={classes.link} href="#" onClick={() => this.props.usermanual()}>
            <Typography color="primary">Automatic Retinal Image Analysis (ARIA) General System Operation Manual</Typography>
          </a>
        </Typography></li></ul>

        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={this.props.onClose}
            className={classes.submitButton}
          >
            Close
          </Button>
        </DialogActions>
      </div>
    )
  }
}

const On9Popup = reduxForm({
  form: 'On9Pupup',
});

export default withStyles(styles)(On9Popup(On9PopupView));
